import { Component, ElementRef, OnInit, ViewChild, OnDestroy, ChangeDetectorRef, ChangeDetectionStrategy } from "@angular/core";
import { ActivatedRoute } from "@angular/router";
import { MateriaService } from "../../../services/materia.service";
import Masonry from 'masonry-layout';
import imagesLoaded from 'imagesloaded';

@Component({
  selector: "app-pesquisa",
  templateUrl: "./pesquisa.component.html",
  styleUrls: ["./pesquisa.component.css"],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false // This is fine, assuming you have a module declaring it
})
export class PesquisaComponent implements OnInit, OnDestroy {
  termoPesquisa: string = "";
  materias: any[] = []; // Initialize as an empty array

  @ViewChild('masonryGrid') masonryGridElem!: ElementRef<HTMLDivElement>;
  private msnry!: Masonry; // Store Masonry instance

  constructor(
    private route: ActivatedRoute,
    private materiaService: MateriaService,
    private cdRef: ChangeDetectorRef // Inject ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.termoPesquisa = this.route.snapshot.paramMap.get("termoPesquisa") || "";
    this.materiaService
      .getPesquisaTermo(this.termoPesquisa)
      .subscribe((res) => {
        this.materias = res || []; // Ensure materias is always an array
        // After data is loaded, Angular needs to render it.
        // We'll trigger Masonry initialization/layout in ngAfterViewInit
        // or by calling a method once data is set.
        this.cdRef.detectChanges(); // Force change detection to render items
        this.initMasonry();
      });
  }

  initMasonry(): void {
    if (this.masonryGridElem && this.masonryGridElem.nativeElement && this.materias.length > 0) {
      // Ensure elements are in the DOM and there's data
      // Use imagesLoaded to wait for images before initializing or laying out
      imagesLoaded(this.masonryGridElem.nativeElement, () => {
        if (this.msnry) { // If Masonry instance already exists, just relayout
          this.msnry.reloadItems();
          this.msnry.layout();
        } else { // Otherwise, create a new instance
          this.msnry = new Masonry(this.masonryGridElem.nativeElement, {
            itemSelector: '.grid-item',
            columnWidth: '.grid-sizer', // Use .grid-sizer for column width
            percentPosition: true,
            gutter: 0, // Adjust this based on your .grid-item padding.
            // If .grid-item has padding: 8px, gutter: 0 works well.
            // Or, if .grid-item has no horizontal padding, gutter: 16 might be what you want.
            //initLayout: true, // Initialize layout immediately
          });
        }
      });
    }
  }

  // Called when an individual image finishes loading
  onImageLoad(): void {
    if (this.msnry) {
      // Use a small timeout to ensure the image dimensions are fully updated in the DOM
      // before Masonry tries to re-layout. This can sometimes be necessary.
      setTimeout(() => {
        this.msnry.layout();
      }, 100);
    }
  }

  public handleMissingImage(event: Event): void {
    const imgElement = event.target as HTMLImageElement;
    // Option 1: Hide the image's parent card if an image is critical
    // imgElement.closest('.card')?.setAttribute('style', 'display:none !important');

    // Option 2: Just hide the image, card remains
    imgElement.style.display = 'none';

    // After hiding, relayout Masonry
    if (this.msnry) {
      setTimeout(() => this.msnry.layout(), 50); // Small delay
    }
  }

  ngOnDestroy(): void {
    if (this.msnry) {
      this.msnry.destroy(); // Clean up Masonry instance
    }
  }
}